import webcrypto from './webcrypto.js'

export default webcrypto
